<template>
  <b-button-toolbar key-nav>
    <template v-if="hasDropdown()">
      <b-dropdown>
        <template #button-content>
          <i :class="`fa ${dropdown.icon}`" />
          <template v-if="dropdown.label">
            {{ dropdown.label }}
          </template>
        </template>
        <template v-for="(item, index) in dropdown.items">
          <b-dropdown-item
            v-if="dropdown.with_action"
            :key="index"
            :title="item.title"
            @click="dropdownAction(item.action_data)"
          >
            <i v-if="item.icon" :class="`fal ${item.icon}`" />
            <template v-if="item.text">
              {{ item.text }}
            </template>
          </b-dropdown-item>
          <b-dropdown-item
            v-else
            :key="index"
            :href="`#${item.linkto}`"
            :title="item.title"
          >
            <i v-if="item.icon" :class="`fal ${item.icon}`" />
            <template v-if="item.text">
              {{ item.text }}
            </template>
          </b-dropdown-item>
        </template>
      </b-dropdown>
    </template>
    <slot name="pre_buttons" />
    <template v-if="hasButtons()">
      <template v-for="(button, index) in buttons">
        <template v-if="button.permission">
          <b-button
            v-if="button.with_action"
            :key="index"
            :class="`ml-1 text-${button.textcolor}`"
            :variant="button.variant"
            :title="button.title"
            :disabled="button.disabled"
            @click="buttonAction(button.action_data)"
          >
            <i v-if="button.icon" :class="`fal ${button.icon}`" />
            <template v-if="button.text">
              {{ button.text }}
            </template>
          </b-button>
          <b-button
            v-else
            :key="index"
            :href="button.linkto ? `#${button.linkto}${link_context ? `?link_id=${link_context}` : ''}` : null"
            :class="`ml-1 text-${button.textcolor}`"
            :variant="button.variant"
            :title="button.title"
            :disabled="button.disabled"
          >
            <i v-if="button.icon" :class="`fal ${button.icon}`" />
            <template v-if="button.text">
              {{ button.text }}
            </template>
          </b-button>
        </template>
      </template>
    </template>
    <slot name="post_buttons" />
  </b-button-toolbar>
</template>

<script>
export default {
  name: "HeaderButtonGroup",
  props: {
    button_config: {
      type: Object,
      default: () => ({
        buttons: [],
        dropdown: {},
      }),
    },
    link_context: {
      required: false,
      default: () => null,
    },
  },
  data() {
    return {
      buttons: [],
      dropdown: {},
      default_config_button: {
        permission: true,
        icon: null,
        text: null,
        linkto: null,
        title: null,
        variant: "primary",
        textcolor: "white",
      },
      default_config_dropdown: {
        icon: "fa-gear",
        label: null,
        items: [],
      },
    };
  },
  methods: {
    dropdownAction(action_data) {
      this.$emit("dropdownAction", action_data);
    },
    buttonAction(action_data) {
      this.$emit("buttonAction", action_data);
    },
    initData() {
      this.buttons = Array.isArray(this.button_config.buttons)
        ? this.button_config.buttons
        : null;
      this.dropdown =
        typeof this.button_config.dropdown === "object"
          ? this.button_config.dropdown
          : null;

      if (this.hasButtons()) {
        for (let i = 0; i < this.buttons.length; i++) {
          this.buttons[i] = Object.assign(
            {},
            this.default_config_button,
            this.buttons[i]
          );
        }
      }

      if (this.hasDropdown()) {
        this.dropdown = Object.assign(
          {},
          this.default_config_dropdown,
          this.dropdown
        );

        if (this.dropdown.items.length) {
          for (let i = 0; i < this.dropdown.items.length; i++) {
            this.dropdown.items[i] = Object.assign(
              {},
              this.default_config_button,
              this.dropdown.items[i]
            );
          }
        }
      }
    },
    hasButtons() {
      return this.buttons !== null && typeof this.buttons !== "undefined";
    },
    hasDropdown() {
      return (
        this.dropdown !== null &&
        typeof this.dropdown !== "undefined" &&
        Array.isArray(this.dropdown.items) &&
        this.dropdown.items.length
      );
    },
  },
  watch: {
    button_config: {
      handler() {
        this.initData();
      },
      deep: true,
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
